import { atom } from 'jotai';

import { type QRInfoError } from '../../types';

export const qrInfoErrorAtom = atom<QRInfoError>(null);

export const qrInfoAtom = atom<string>('');
